import(/* webpackMode: "eager" */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ActiveChannelWrapper"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/components/ActiveChannelWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthContextProvider"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/components/AuthProvider/authContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSizeMonitor"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/components/CookieSizeMonitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/components/navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationCenter"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/components/notifications/NotificationCenter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/components/themeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationSyncProvider"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/components/TranslationSyncProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MultiAccountProvider"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/hooks/useMultiAccount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebSocketProvider"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/lib/websocket/WebSocketProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/home/runner/work/AlUmmahNow/AlUmmahNow/node_modules/nuqs/dist/adapters/next/app.js");
